import { Route } from '../core/routeGuard/applicationRoutesNg.service';
import { COOKIE_NAMES } from '../core/util/cookieManager.service';
import { USE_NEW_SIGN_IN_PROCESS } from './use-new-sign-in-process';

export default class ChooseOrganizationController {
  organizations;

  get cookieNames() {
    return COOKIE_NAMES;
  }

  constructor(private $window, private DestinationService, private cookieManager) {
    'ngInject';

    if(USE_NEW_SIGN_IN_PROCESS) {
      this.$window.location.href = Route.CHOOSE_ORG;
    }

    DestinationService.getOrganizations().then((organizations) => {
      // This should return an array of organizations from which the user can pick.
      this.organizations = organizations;

      if (organizations.length === 1) {
        DestinationService.nextDestination();
      }
    });
  }

  choose(orgId) {
    this.DestinationService.chooseOrganization(orgId).then(() => {
      this.DestinationService.nextDestination();
      this.cookieManager.removeCookie(
        this.cookieNames.EXECECUTE_LIST_GRID_STATE
      );
    });
  }

  logout() {
    this.DestinationService.logout();
  }
}
